import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Widget/AddToBag.js";

/**
* class HSN.BuyAgain
* Handles add-to-bag-handler buttons for sitewide widgets
**/
HSN.BuyAgain = (function() {
    var clickHandler = function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var cur = $(ev.currentTarget);
        var productId = cur.data('webpid');
        var productStyleId = cur.data('webid');
        if (productId !== 0 && productStyleId !== 0) {
            HSN.SetWait();

            var options = {
                ProductId : productId,
                WebId : productStyleId,
                DeferredFinancing : null,
                ExtraFlexPromo : null,
                ExtraFlex : null,
                ExpressBuy : 0,
                Quantity : 1,
                FlexPay : 1,
                ProgramId: cur.data('autoship-program-id'),
                ProgramCode : cur.data('autoship-program-code'),
                Frequency : cur.data('autoship-program-frequency'),
                StartDate : cur.data('autoship-program-start-date'),
                WarrantyWebPId : null,
                WarrantyName : null,
                WarrantyAmount : null
            };

            var addToBagWidget = new HSN.Widget.AddToBag();
            addToBagWidget.init({
                application : HSN.Instance(),
                isInPreviewModal : false,
                refreshWhenDone: true
            });
            addToBagWidget.AddToBag(options);
        }
        else {
            alert('Unfortunately there was an error attempting to add the item to your bag, please try again.');
        }
    };

    $(document).ready(function() {
        $(document).on('click', '.add-to-bag-handler', clickHandler);
    });
})();




// WEBPACK FOOTER //
// ./assets/js/HSN/BuyAgain.js